(function () {
  const header = document.querySelector(".hk3");
  if (!header) return;

  const drawer = header.querySelector("[data-hk3-drawer]");
  const burger = header.querySelector("[data-hk3-burger]");
  const closeBtn = header.querySelector("[data-hk3-close]");
  const backdrop = header.querySelector("[data-hk3-backdrop]");

  function openDrawer() {
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
  }

  function closeDrawer() {
    drawer.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  }

  burger && burger.addEventListener("click", openDrawer);
  closeBtn && closeBtn.addEventListener("click", closeDrawer);
  backdrop && backdrop.addEventListener("click", closeDrawer);

  // Improve accessibility: close on ESC
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && drawer.getAttribute("aria-hidden") === "false") {
      closeDrawer();
    }
  });

  // Set aria-expanded on hover/focus for desktop items
  const items = header.querySelectorAll("[data-hk3-item]");
  items.forEach((li) => {
    const a = li.querySelector("a.hk3__link--has");
    if (!a) return;

    li.addEventListener("mouseenter", () => a.setAttribute("aria-expanded", "true"));
    li.addEventListener("mouseleave", () => a.setAttribute("aria-expanded", "false"));
    a.addEventListener("focus", () => a.setAttribute("aria-expanded", "true"));
    a.addEventListener("blur", () => a.setAttribute("aria-expanded", "false"));
  });
})();
